<div class="Dialog">
  <mat-toolbar color="primary" class="Dialog__header">
    <h2 class="Dialog__title" mat-dialog-title>{{ title | translate }}</h2>
    <span class="flex-1"></span>
    <button mat-icon-button type="button" (click)="dismiss()"><mat-icon>close</mat-icon></button>
  </mat-toolbar>
  <div class="Dialog__content" mat-dialog-content>
    <div class="Dialog__inner">
      <p [innerHTML]="message | translate"></p>
    </div>
  </div>
  <div class="Dialog__actions" mat-dialog-actions>
    <span class="flex-1"></span>
    <button type="button" mat-button *ngFor="let button of secondaryButtons" (click)="dialogRef.close(button.value)">
      {{ button.label }}
    </button>
    <button type="button" mat-raised-button color="primary" (click)="dialogRef.close(primaryButton.value)">
      {{ primaryButton.label }}
    </button>
  </div>
</div>
